import React, { useCallback } from 'react';
import Result from './Result';
import useSearch from './useSearch';
import useScrollPositioning from './useScrollPositioning';
import classnames from 'classnames';
import renderIf from 'render-if';
import Spinner from '../common/Spinner';

// Global cache because we only expect to have one of these on a page at any given time.
// This helps us mount & unmount the component with the same state.
const newCache = () => {
  return {
    results: [],
    customProjectFacet: () => {
      return window.currentProjectId;
    },
    customSearchableTypeFacet: () => {
      return window.AhaSearchContext?.pageInfo?.searchable_type;
    },
    customWorkflowStatusFacet: () => {
      return null;
    },
    scroll: {
      top: 0,
      query: null,
    },
    currentPage: 1,
    name: 'Current page',
  };
};

let cache = newCache();
document.addEventListener('aha.fred.error', () => {
  cache = newCache();
});

const InContextSearch = ({ query }) => {
  const { results, loadingResults, fetchMore, fetchingMore } = useSearch({
    query,
    resultsQuery: useCallback(() => {
      return {
        q: `${query}*`,
        searchable_type: window.AhaSearchContext.pageInfo.searchable_type,
        project_id: window.currentProjectId,
      };
    }, [query]),
    facetsQuery: useCallback(() => {
      return null;
    }, []),
    cache,
  });

  const { setScroll, resultsRef } = useScrollPositioning({
    cache,
    query,
    fetchMore,
  });

  return (
    <>
      <div className='search'>
        <div
          className={classnames({
            results: true,
            'results--loading': loadingResults,
            'results--fetching-more': fetchingMore,
          })}
          ref={resultsRef}
          onScroll={e => {
            setScroll(e.target.scrollTop);
          }}
        >
          {renderIf(loadingResults)(<Spinner />)}

          {renderIf(!loadingResults)(
            <>
              {results.map((result, index) => {
                return (
                  <Result
                    key={result.url}
                    result={result}
                    showProject={false}
                    timestampCopy={'Last updated:'}
                  />
                );
              })}

              {renderIf(results.length === 0 && query.length !== 0)(
                <div className='empty'>
                  <h3>No results</h3>
                </div>
              )}

              {renderIf(results.length === 0 && query.length === 0)(
                <div className='empty'>
                  <h3>Start typing to search records</h3>
                </div>
              )}

              {renderIf(fetchingMore)(<Spinner />)}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default InContextSearch;
